import React from 'react';
// styles
import { RelatedLinksStyled } from './styles';

export default () => {
  const linkItems = [
    {
      linkUrl: '/investment-product-information/',
      linkId: 'related-links-investment-product-information',
      linkText: 'Investment product information',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/investing-disclosure/',
      linkId: 'related-links-investing-disclosure',
      linkText: 'Investing disclosure',
      ariaLabel: 'See our investing disclosure',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/mutual-funds-partners/',
      linkId: 'related-links-mutual-fund-partners',
      linkText: 'Mutual fund partners',
      ariaLabel: 'Learn more about our mutual fund partners',
      isOutgoingLink: true,
      children: '',
    },
  ];

  return (
    <RelatedLinksStyled
      sectionId='related-links-brokerage-accounts-services-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      disableBottomPadding />
  );
};
